import { Component, Inject, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCalibration } from 'app/dtos/calibration/createCalibration';
import { CalibrationStatus } from 'app/enum/calibrationStatus';
import { _acreditionCompanyId, _isPersonId } from 'app/services/auth.service';
import { CalibrationService } from 'app/services/models/calibration.service';
import { DeliveryDeviceService } from 'app/services/models/delivery-device.service';
import { DeviceClassService } from 'app/services/models/device-class.service';
import { DeviceService } from 'app/services/models/device.service';
import { EnvironmentalConditionService } from 'app/services/models/environmental-condition.service';
import { PersonService } from 'app/services/models/person.service';
import { ProcedureService } from 'app/services/models/procedure.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { UpdateDeviceDialogComponent } from '../update-device-dialog/update-device-dialog.component';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { CertificateService } from 'app/services/models/certificate.service';
import { CertificateReservationService } from 'app/services/models/certificate-reservation.service';
import moment from 'moment';
import { CalibrationData, CalibrationPage2, headerBilgileri, Reference } from '../create-certificate-dialog/create-certificate-dialog.component';
import * as pdfjsLib from 'pdfjs-dist';
import QRCode from 'qrcode';
import { PdfFontService } from 'app/services/common/pdf-font.service';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { CalibrationlogoEnum } from 'app/enum/calibrationlogoEnum';
import htmlToPdfmake from 'html-to-pdfmake';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import * as pdfMake from 'pdfmake/build/pdfmake';
import { TurkakService } from 'app/services/api/turkak.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { CalibrationCertificate } from 'app/services/api/apiDtos/CalibrationCertificate';
import { CompanyService } from 'app/services/models/company.service';
import { CertificateReservationDialogComponent } from '../certificate-reservation-dialog/certificate-reservation-dialog.component';
import { CustomerSettingService } from 'app/services/models/customer-setting.service';
import { GetCustomerSettingDetailDTO } from 'app/dtos/customer-setting/getCustomerSettingDetailDTO';
import { MeasurementResultService } from 'app/services/models/measurement-result.service';
import { ControllerType, HttpClientService } from 'app/services/http-client.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CreateEnvironmentalConditionComponent } from '../create-environmental-condition/create-environmental-condition.component';
// import { vfs } from 'pdfmake/build/vfs_fonts';
// (pdfMake as any).vfs = vfs;
// (pdfMake as any).fonts = {
//   RobotoSerif: {
//     normal: 'RobotoSerif-Regular.ttf', // Add the font path to the VFS here
//     bold: 'RobotoSerif-Bold.ttf',      // Add the font path to the VFS here
//     italics: 'RobotoSerif-Italic.ttf', // Add the font path to the VFS here
//     bolditalics: 'RobotoSerif-BoldItalic.ttf', // Add the font path to the VFS here
//   }
// };

@Component({
  selector: 'app-calibartion-create-dilaog',
  templateUrl: './calibartion-create-dilaog.component.html',
  styleUrls: ['./calibartion-create-dilaog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalibartionCreateDilaogComponent implements OnInit {
  @Input() data: { id: number, dialogTitle: string; };
  @ViewChild('procedure') procedure!: NgModel;

  public coreConfig: any;
  private _unsubscribeAll: Subject<any>;
  certificateForm: FormGroup; // Form için tanımlama

  calibrationDevice: any = {};
  procedures: any[] = [];
  kindProcedures: any[] = []
  selectProcedureId: number = null;
  selectProcedure: any = {};
  public basicPwdShow = false;
  refereceDevices: any[] = [];
  persons: any[] = [];
  calPersons: any[] = [];
  selectedPersonId: number = null;

  selectedDevices: any[] = [];
  selectedDevice: any;

  date = new Date();
  date2 = new Date();

  environmentalContent: any[] = [];
  enviromentalContentId: number;

  isPlace: boolean = true;

  date3 = Number(_acreditionCompanyId) == 1 ? moment().add(1, 'day').toDate() : moment().toDate();
  date4 = moment().add(1, 'year').toDate();

  measurementResults: any[] = [];
  selectMeasurementId: number = null;
  public dateTimeCertificateStartOptions: FlatpickrOptions = {
    altInput: true,
    altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimeCertificateEndOptions: FlatpickrOptions = {
    altInput: true,
    altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultDate: this.date
  };

  selectedAcradtionOrganizationId = null;
  akradetionOrganization = [
    { id: 1, name: "Türkak" },
    { id: 2, name: "NAC" },
    { id: 3, name: "İzlenebilirik" },
    { id: 4, name: "IAS" }
  ];

  certificateNumber: string = null;
  certificateReservations?: any[] = [];
  calibrationAddress: string = '';
  company: any = {};

  certificateFirstNo: string = null;

  pdfUrl: SafeResourceUrl | null = null;
  selectedFileName: string = 'Dosya Seç';

  constructor(
    public activeModal: NgbActiveModal,
    private deliveryDeviceService: DeliveryDeviceService,
    private procedureService: ProcedureService,
    private personService: PersonService,
    private deviceService: DeviceService,
    private toastrService: ToastrService,
    private calibrationService: CalibrationService,
    private router: Router,
    private _coreConfigService: CoreConfigService,
    private modalService: NgbModal,
    private environmentalConditionService: EnvironmentalConditionService,
    private fb: FormBuilder,
    private certificateService: CertificateService,
    private certificateReservationService: CertificateReservationService,
    @Inject('backendUrl') private backendUrl: string,
    private pdfFontService: PdfFontService,
    private turkakService: TurkakService,
    private companyService: CompanyService,
    private customerSettingService: CustomerSettingService,
    private measurementResultService: MeasurementResultService,
    private httpClientService: HttpClientService,
    private sanitizer: DomSanitizer
  ) {
    this._unsubscribeAll = new Subject();
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';

  }

  async ngOnInit() {
    this.certificateForm = this.fb.group({
      certificateNo: [this.certificateNumber],
      issueDate: ['', Validators.required],
      expiryDate: ['', Validators.required],
      visualAndFunctional: [true],
      personId: [null, Validators.required]
    });
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
    this.certificateFirstNo = this.coreConfig.certificateFirstNo;
    await this.getByIdCalibrationDeviceId(this.data.id);
    console.log(this.coreConfig);
    this.selectedAcradtionOrganizationId = this.coreConfig.akraditasyonCompanies.defaultId
    await this.getLastCerticateNumber();
    if (!this.selectProcedureId) {
      this.procedure.control.markAsTouched();
      this.procedure.control.updateValueAndValidity();
    }
  }

  async getLastCerticateNumber() {
    const data = await this.certificateService.getLastCertificate();
    this.certificateNumber = data;
    setTimeout(() => {
      this.certificateForm.patchValue({
        certificateNo: this.certificateNumber
      });
    });
  }

  onReservationSelect(reservation: any) {
    console.log(reservation);
    if (reservation) {
      this.certificateNumber = reservation.reservedCertificateNo;
      this.certificateForm.patchValue({
        certificateNo: this.certificateNumber
      });
    }
  }

  async getAllCertificateReservations(companyId) {
    const data = await this.certificateReservationService.getByIdCompanyCertificateReservations(companyId);
    this.certificateReservations = data;
    console.log(this.certificateReservations);
  }

  updateDeviceModal(id) {
    const modal = this.modalService.open(UpdateDeviceDialogComponent, {
      windowClass: 'modal modal-warning',
      centered: true,
      size: 'lg'
    });
    modal.componentInstance.data = {
      id: id,
      isReferenceDevice: false
    };
    modal.result.then(async () => {
      await this.getByIdCalibrationDeviceId(this.data.id);
    });
  }

  addReservation() {
    const modal = this.modalService.open(CertificateReservationDialogComponent, {
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      companyId: this.calibrationDevice.company.id,
      data: null
    };
    modal.result.then(async (result) => {
      if (result == true) {
        await this.getAllCertificateReservations(this.calibrationDevice.company.id);
        this.onReservationSelect(this.certificateReservations[this.certificateReservations?.length - 1])
      }
    })
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async getAllEnvironmentalCondition(kindId) {
    const data = await this.environmentalConditionService.getAllEnvironmentalCondition(0, 100, kindId);
    console.log(data);
    this.environmentalContent = data.environmental;
    this.enviromentalContentId = this.environmentalContent[0]?.id
  }

  async getByIdCalibrationDeviceId(id) {
    const data = await this.deliveryDeviceService.getByIdDeliveryDeviceCalibration(id);
    this.calibrationDevice = data;
    const missingFields = [];
    if (!this.calibrationDevice.seriNo) missingFields.push("Seri Numarası");
    if (!this.calibrationDevice.brandName) missingFields.push("Marka");
    if (!this.calibrationDevice.modelName) missingFields.push("Model");
    if (!this.calibrationDevice.resolution) missingFields.push("Çözünürlük");
    if (!this.calibrationDevice.place) missingFields.push("Yer");
    if (!this.calibrationDevice.inventoryNumber) missingFields.push("Envanter No");

    this.company = await this.companyService.getByIdCompany(1);
    this.onPlaceChange(true)
    console.log(this.company);
    this.akradetionOrganization = this.akradetionOrganization.filter(p => p.id == this.company.acraditionCompanyId || p.id == 3)
    if (missingFields.length > 0) {
      const message = `Kalibrasyon yapılan cihazın şu bilgileri eksik: ${missingFields.join(", ")}`;
      this.toastrService.warning(message, "Eksik Bilgi Uyarısı", {
        progressBar: true,
        toastClass: 'toast ngx-toastr',
        positionClass: 'toast-bottom-right',
        closeButton: true
      });
    }
    console.log(this.calibrationDevice);
    await this.getAllEnvironmentalCondition(this.calibrationDevice.kindId);
    await this.getByKindIdProcedures(this.calibrationDevice.kindId, this.calibrationDevice.referenceId);
    await this.getAllProcedure();
    await this.getAllPerson(['calibratedConfirming']);
    await this.getAllPerson(['calibratonperson']);
    await this.getAllReferenceDevice(this.calibrationDevice.kindId);
    await this.getAllCertificateReservations(this.calibrationDevice.company.id)
    if ((this.coreConfig.isCalibratedTurkak == true && this.calibrationDevice.certificateCompanyTurkakId == null && this.selectedAcradtionOrganizationId == 1)) {
      this.toastrService.error("Bu firma türkaka kaydedilmemiştir", "Firma Türkak");
    }
    await this.getAllMeasurementResults(this.calibrationDevice.kindId, this.calibrationDevice.referenceId);
  }

  onPlaceChange(value: boolean) {
    this.isPlace = value;
    if (value) {
      // Yerinde seçildiyse calibrationDevice içindeki adres alınır
      this.calibrationAddress = this.calibrationDevice?.certificateCompanyAddress || '';
    } else {
      // Laboratuvar seçildiyse company içindeki adres alınır
      this.calibrationAddress = this.company?.address || '';
    }
  }


  async getAllProcedure() {
    const data = await this.procedureService.getAllProcedures(0, 6);
    this.procedures = data.procedures;
  }

  async getByKindIdProcedures(kindId, referenceId?: number) {
    const data = await this.procedureService.getByKindIdProcedures(kindId, referenceId);
    this.kindProcedures = data;
    console.log(this.kindProcedures);
    if (this.kindProcedures.length == 1) {
      this.selectProcedureId = this.kindProcedures[0].id; // İlk elemanın ID'sini al
    }
  }

  calCompanyPerson = [];
  async getAllPerson(codes?: string[]) {
    const data = await this.personService.getAllCompaniesPersons(0, 500, 1, codes);
    console.log(data);
    if (codes.includes("calibratonperson")) {
      this.calCompanyPerson = data.persons.map(person => ({
        ...person,
        fullName: person.name + ' ' + person.lastName
      }));
      if (this.calCompanyPerson?.length === 1) {
        this.certificateForm.patchValue({
          personId: this.calCompanyPerson[0].id
        })
      }
    }
    if (codes.includes("calibratedConfirming")) {
      this.persons = data.persons.map(person => ({
        ...person,
        fullName: person.name + ' ' + person.lastName
      }));
      const pers = this.persons?.find(p => p.id === Number(_isPersonId));
      if (pers != null)
        this.selectedPersonId = pers?.id ?? null;

      //this.selectedPersonId = this.persons[0]?.id
    }
  }

  async getAllMeasurementResults(kindId: number, referenceId?: number) {
    const data = await this.measurementResultService.getByKindMeasurementResult(kindId, referenceId);
    console.log(data);
    this.measurementResults = data.map(x => {
      return {
        ...x,
        fileName: this.getFileName(x.fileName) // buraya yazıyoruz ✔️
      };
    });
    if (this.measurementResults.length == 1) {
      this.selectMeasurementId = this.measurementResults[0]?.id;
    }
  }

  getFileName(i: string): string {
    const file: any = i; // 👈 burada tipini 'any' yaptık

    if (!file) return '';

    // 🟢 2. Backend’den gelen string path
    if (typeof file === 'string') {
      // 'procedures/....-dosya-adi.pdf'
      const fileName = file.split('/').pop() || '';
      const parts = fileName.split('-');
      // 🟢 5. tireden sonrasını al
      return parts.length > 5 ? parts.slice(5).join('-') : fileName;
    }

    // 🟡 3. Diğer tüm durumlar
    return '';
  }

  async convert() {
    if (!this.selectedFile) return;

    const toastRef = this.toastrService.info(
      'Ölçüm Sonucu yükleniyor...',
      'Lütfen bekleyiniz',
      {
        disableTimeOut: true, // 🔴 otomatik kapanmasın
        tapToDismiss: false,  // tıklayınca kapanmasın
        closeButton: false
      }
    );
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    const response$ = this.httpClientService.post(
      {
        controller: ControllerType.Deneme,
        action: 'convert',
      },
      formData
    );

    const response: any = await firstValueFrom(response$);
    console.log(response);
    // 🔴 Base64 → PDF iframe src
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `data:${response.contentType};base64,${response.base64}`
    );
    this.toastrService.clear(toastRef.toastId);
  }

  async downloadSelectedFile() {
    if (!this.selectMeasurementId) return;

    const selected = this.measurementResults.find(x => x.id === this.selectMeasurementId);
    const originalFileName = selected.fileName;
    const extension = originalFileName.substring(
      originalFileName.lastIndexOf('.')
    );

    if (!selected || !selected.filePath) {
      console.warn("Dosya bulunamadı");
      return;
    }
    console.log(this.selectedDevices);

    const loadingToast = this.toastrService.info(
      'Dosya indiriliyor, lütfen bekleyin...',
      'İndirme',
      {
        disableTimeOut: true,
        closeButton: false,
        progressBar: true
      }
    );

    try {
      const references = this.selectedDevices?.map(device => ({
        deviceName: device.deviceName,
        serialNumber: device.seriNo,
        acceptanceCriterion: device?.referenceDeviceMovement?.acceptanceCriterion,
        calibrationCertificateUncertainty:
          device?.referenceDeviceMovement?.calibrationCertificateUncertainty
      }));

      const deviceInfo = {
        deviceName: this.calibrationDevice.deviceName,
        seriNo: this.calibrationDevice.seriNo,
        resolution: this.calibrationDevice.resolution,
        inventoryNumber: this.calibrationDevice.inventoryNumber,
        kindName: this.calibrationDevice.typeName
      };

      const companyInfo = {
        companyName: this.calibrationDevice.certficateCompany,
        companyAdres: this.calibrationDevice.certificateCompanyAddress
      };

      const fileName =
        `${this.calibrationDevice.seriNo ? this.calibrationDevice.seriNo + '-' : ''}` +
        `${this.calibrationDevice.code}-${this.calibrationDevice.deliveryCode}`;

      const blob = await this.measurementResultService.downloadMeasurementFile(
        selected.id,
        selected.fileName,
        references,
        fileName,
        companyInfo,
        deviceInfo
      );

      // ⬇ Dosyayı indir
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = fileName + extension; // 🔥 dinamik uzantı
      a.click();
      URL.revokeObjectURL(a.href);

      // ✅ Loading toastr kapat
      this.toastrService.clear(loadingToast.toastId);

      // ✅ Başarılı toastr
      this.toastrService.success('Dosya başarıyla indirildi', 'Tamam');

    } catch (error) {
      console.error(error);

      // ❌ Loading toastr kapat
      if (loadingToast) {
        this.toastrService.clear(loadingToast.toastId);
      }

      // ❌ Hata toastr
      this.toastrService.error(
        'Dosya indirilemedi, lütfen tekrar deneyin',
        'Hata'
      );
    }
  }

  formatDateForFile(dateString: string): string {
    if (!dateString) return '';

    const d = new Date(dateString);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hour = String(d.getHours()).padStart(2, '0');
    const minute = String(d.getMinutes()).padStart(2, '0');
    const second = String(d.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hour}${minute}${second}`;
  }

  downloadFileFromUrl(url: string, fileName: string) {

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('Dosya alınamadı');
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(error => {
        console.error('İndirme hatası:', error);
      });

  }

  async getAllReferenceDevice(kindId) {
    const data = await this.deviceService.getAllDevices(0, 1000, '', 1, kindId);
    console.log(data);
    this.refereceDevices = data.devices;
  }

  removeDevice(device: any) {
    this.selectedDevices = this.selectedDevices.filter(d => d.id !== device.id);
  }

  async onProcedureChange() {
    if (!this.selectProcedureId || this.selectedDevices.length > 0) {
      return; // seçim yoksa veya zaten cihaz seçildiyse işlem yapma
    }

    // 1️⃣ Seçilen prosedürü bul
    const selectedProcedure = this.kindProcedures.find(
      p => p.id === this.selectProcedureId
    );

    if (!selectedProcedure || !selectedProcedure.referenceId) {
      console.warn('Prosedür veya referenceId bulunamadı');
      return;
    }

    // 2️⃣ İlgili referans ID’ye göre cihazları getir
    if (!this.refereceDevices || this.refereceDevices.length === 0) {
      await this.getAllReferenceDevice(selectedProcedure.kindId);
    }

    // 3️⃣ Referans ID eşleşen cihazları bul
    const matchedDevices = this.refereceDevices.filter(
      d => d.referenceId === selectedProcedure.referenceId
    );

    // 4️⃣ Sadece selectedDevices boşsa ekle
    if (this.selectedDevices.length === 0 && matchedDevices.length > 0) {
      this.selectedDevices.push(...matchedDevices);
      console.log('Otomatik eklenen cihazlar:', matchedDevices);
    }
  }

  onDeviceSelect(device: any) {
    // Eğer cihaz daha önce seçilmemişse, listeye ekle
    if (device.isCalibrationValid) {
      if (device && !this.selectedDevices.find(d => d.id === device.id)) {
        this.selectedDevices.push(device);
      }
    } else {
      this.toastrService.error("Bu cihazın kalibrasyon durumu pasif bu yüzden referans cihaz olarak ekliyemezsin.");
    }
    this.selectedDevice = null;
  }

  isSaveDisabled(): boolean {
    return !this.enviromentalContentId ||
      !this.selectProcedureId ||
      !this.date ||
      !this.selectedPersonId ||
      !this.selectedAcradtionOrganizationId ||
      this.selectedDevices?.length < 1 ||
      !this.calibrationAddress?.trim() ||
      (
        this.coreConfig.isCalibratedTurkak === true &&
        this.selectedAcradtionOrganizationId === 1 &&
        this.calibrationDevice.certificateCompanyTurkakId == null
      )
      ||
      this.certificateForm.invalid
  }

  formatTurkakDate(date: Date | string): string {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  // Tarih + saat formatı:
  formatTurkakDateTime(date: Date | string): string {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ` +
      `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
  }

  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('Base64 dönüşüm hatası'));
      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  }

  measurementResultBase64: any = null;;

  async getCalibrationMeasurementResultBase64(path: string) {
    var result = await this.calibrationService.getCalibrationMeasurementResultBase64(path);
    console.log(result);
    if (result.base64 != null)
      this.measurementResultBase64 = await this.convertPdfPagesToImages(result.base64);

    //await this.loadPdfFromBase64(this.measurementResultBase64);
  }

  async convertPdfPagesToImages(pdfBase64: string): Promise<any[]> {
    if (!pdfBase64) return [];

    const pdfData = atob(pdfBase64);
    const pdfContainer = document.getElementById('pdf-container');

    // Konteyner temizleme ve başlık ekleme (Önizleme amacıyla)
    if (!pdfContainer) {
      console.warn('PDF önizleme konteyneri (#pdf-container) bulunamadı.');
    } else {
      pdfContainer.innerHTML = '';
      const header = document.createElement('h3');
      header.textContent = 'Ölçüm Sonuçları PDF Önizlemesi (Canvas)';
      pdfContainer.appendChild(header);
    }

    // PDF.js ile PDF'i yükle
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const numPages = pdf.numPages;
    const imagesArray: any[] = [];

    // !!! onFileSelected2'den alınan ÖLÇEK DEĞERİ !!!
    const scaleFactor = 4.0;

    // !!! onFileSelected2'den alınan KIRPMA PARAMETRELERİ !!!
    const cropTop = 340;
    const cropBottom = 390;
    const cropLeft = 0;
    const cropRight = 0;

    for (let i = 1; i <= numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: scaleFactor }); // Yüksek ölçek kullanıldı

      // 1. ADIM: Tam sayfa render için canvas
      const fullCanvas = document.createElement('canvas');
      const fullContext = fullCanvas.getContext('2d')!;
      fullCanvas.height = viewport.height;
      fullCanvas.width = viewport.width;

      // Sayfayı tam olarak canvas'a render et
      await page.render({ canvasContext: fullContext, viewport: viewport }).promise;

      // 2. ADIM: Kırpma için yeni canvas oluştur
      const cropCanvas = document.createElement('canvas');
      const cropContext = cropCanvas.getContext('2d')!;

      const cropHeight = fullCanvas.height - cropTop - cropBottom;
      const cropWidth = fullCanvas.width - cropLeft - cropRight;

      cropCanvas.width = cropWidth;
      cropCanvas.height = cropHeight;

      // Kırpma işlemini uygula
      cropContext.drawImage(
        fullCanvas,
        cropLeft, cropTop, // Kaynak başlangıç
        cropWidth, cropHeight, // Kaynak boyut
        0, 0, // Hedef başlangıç
        cropWidth, cropHeight // Hedef boyut
      );

      // Bellek temizliği için tam canvas'ı kaldır
      fullCanvas.remove();

      // !!! GÖRÜNTÜLEME İŞLEMİ (KIRPILMIŞ RESİM) !!!
      if (pdfContainer) {
        // Kırpılmış canvasi DOM'a ekle ve stil ver
        cropCanvas.style.maxWidth = '100%';
        cropCanvas.style.height = 'auto';
        cropCanvas.style.border = '1px solid #ccc';
        cropCanvas.style.margin = '10px 0';

        const pageHeader = document.createElement('h4');
        pageHeader.textContent = `Sayfa ${i} (Kırpılmış)`;
        pdfContainer.appendChild(pageHeader);

        pdfContainer.appendChild(cropCanvas);
      }
      // !!! GÖRÜNTÜLEME İŞLEMİ SONU !!!


      // Kırpılmış Canvas'ı Base64 resim verisine dönüştür (pdfmake için)
      const base64Image = cropCanvas.toDataURL('image/jpeg', 0.95);

      // Base64 görseli oluşturulduktan sonra, DOM'a eklenmediği sürece bellekten kaldır
      // (Ancak yukarıda DOM'a eklediğimiz için bu satırı kullanmıyoruz.)
      // cropCanvas.remove(); 

      // pdfmake içeriği olarak ekle
      imagesArray.push({
        image: base64Image,
        // A4 sayfasında maksimum genişlik (mevcut kenar boşluklarına uygun)
        width: 525,
        pageBreak: i < numPages ? 'after' : undefined
      });
    }

    return imagesArray;
  }

  turkakQrBase64;
  certificationBodyDocumentNumber: string = null;
  isSaving = false;
  async saveData(isSave: boolean) {
    if (this.isSaving) return; // ✅ işlem zaten devam ediyorsa fonksiyon çalışmasın

    console.log(this.selectedDevices);
    this.isSaving = true

    this.customerSetting = await this.customerSettingService.getCustomerSettingDetail(1);

    if (this.customerSetting.accreditationNo == null) {
      this.toastrService.error("Akreditasyon numarasını ayaralara girmeden kalibrasyon işlemi yapamazsınız");
      return;
    }

    if (Number(_acreditionCompanyId) == 1) {
      if (this.customerSetting.turkakLogo == null)
        this.toastrService.success("Turkak logosunu ayarlara girin")
    }

    if (Number(_acreditionCompanyId) == 2) {
      if (this.customerSetting.turkakLogo == null) {
        this.toastrService.success("Nac logosunu ayarlara girin");
        return;
      }
    }

    if (Number(_acreditionCompanyId) == 4) {
      if (this.customerSetting.turkakLogo == null) {
        this.toastrService.success("IAS logosunu ayarlara girin")
        return;
      }
    }

    if (this.customerSetting.certificatePrefix == null) {
      this.toastrService.success("Sertfika Başlangıç karakterini belirleyip ayarlara giriniz");
      return;
    }

    if (this.customerSetting.stampImage == null) {
      this.toastrService.success("Mühür logosunu ayarlara girin")
      return;
    }

    if (this.selectedDevices.length === 0) {
      this.toastrService.error("Referans cihazlar zorunludur. Lütfen en az bir referans cihaz ekleyin.");
      return;
    }

    const serialNumbers = this.selectedDevices.map(ref => ref.seriNo).join(',');

    const calibrationDate = this.date[0]?.setHours(3) ?? this.date?.setHours(3);
    const firstReleaseDate = this.certificateForm.value.issueDate?.[0] ?? this.certificateForm.value.issueDate;

    const person = this.persons.find(p => p.id == this.selectedPersonId);
    console.log(person);
    let turkakCalibrationId: string | null = null;

    const turkakCertificate = await this.turkakService.getCertificate(turkakCalibrationId);

    //const certID = turkakCertificate?.ID;
    //const tbdsNumber = turkakCertificate?.CertificationBodyDocumentNumber;
    // const qrBlob = await this.turkakService.getCertificateQrPng(certID, tbdsNumber); // URL: /GetQR/{certID}/{tbdsNumber}
    // if (qrBlob) {
    //  this.turkakQrBase64 = await this.convertBlobToBase64(qrBlob);
    //  console.log(this.turkakQrBase64);
    //}

    if (isSave) {
      let turkakPayload: CalibrationCertificate[] = [{
        CustomerID: this.calibrationDevice.certificateCompanyTurkakId,
        CalibrationDate: this.formatTurkakDateTime(calibrationDate), // 👈 string olarak ve doğru formatta
        CalibrationLocation: this.calibrationAddress, //this.calibration.isPlace ? 'Yerinde' : 'Laboratuvarda',
        DeviceSerialNumber: this.calibrationDevice.seriNo,
        MachineOrDeviceType: this.calibrationDevice.typeName,
        FirstReleaseDateOfTheDocument: this.formatTurkakDate(firstReleaseDate), // 👈 string
        PersonnelPerformingCalibration: `${person.name} ${person.lastName}`,
        SerialNumberOfReferenceCalibrator: serialNumbers,
        // CertificationBodyDocumentNumber:`${this.certificationBodyDocumentNumber}`,
        State: null
      }];
      if (this.coreConfig.isCalibratedTurkak && this.selectedAcradtionOrganizationId === 1) {
        try {

          // BURASI ARTIK CERTFİCATE DİALOĞUNDA ÇALIŞACAK

          /* const turkakResponse = await this.turkakService.saveCertificates(turkakPayload);
           console.log('TÜRKAK yanıtı:', turkakResponse);
 
           if (turkakResponse?.Item1?.length > 0) {
             turkakCalibrationId = turkakResponse.Item1[0].ID
             let turkakCertificate = null;
             const maxRetries = 8;  // toplam deneme sayısı
             const delayMs = 3000;  // 5 saniye bekleme
 
             //const turkakCertificate = await this.turkakService.getCertificate(turkakCalibrationId);
 
             for (let attempt = 1; attempt <= maxRetries; attempt++) {
               turkakCertificate = await this.turkakService.getCertificate(turkakCalibrationId);
               console.log(`TÜRKAK sertifika deneme ${attempt}:`, turkakCertificate);
 
               if (turkakCertificate?.CertificationBodyDocumentNumber) {
                 console.log('CertificationBodyDocumentNumber bulundu ✅');
                 break;
               }
 
               if (attempt < maxRetries) {
                 console.log(`CertificationBodyDocumentNumber henüz gelmedi, ${delayMs / 1000} saniye bekleniyor...`);
                 await new Promise(resolve => setTimeout(resolve, delayMs));
               }
             }
 
             if (!turkakCertificate?.CertificationBodyDocumentNumber) {
               this.toastrService.warning(
                 "CertificationBodyDocumentNumber bilgisi henüz TÜRKAK sisteminden alınamadı.",
                 "TÜRKAK Uyarısı"
               );
               return; // devam etmiyoruz çünkü bilgi eksik
             }
 
 
             console.log(turkakCertificate);
             if (turkakCertificate != null) {
               this.certificationBodyDocumentNumber = turkakCertificate.CertificationBodyDocumentNumber;
               const certID = turkakCertificate.ID;
               const tbdsNumber = turkakCertificate.TBDSNumber;
               const qrBlob = await this.turkakService.getCertificateQrPng(certID, tbdsNumber); // URL: /GetQR/{certID}/{tbdsNumber}
               this.turkakQrBase64 = await this.convertBlobToBase64(qrBlob);
 
              
             }
           } else if (turkakResponse?.Item2?.length > 0) {
             turkakResponse.Item2.forEach((item: any) => {
               this.toastrService.error(item.ErrorDescription || 'TÜRKAK hatası oluştu.');
             });
             return;
           } else {
             this.toastrService.error('TÜRKAK servisi boş bir yanıt döndü.');
             return;
           }
             */
        } catch (error) {
          console.error('TÜRKAK isteği hatası:', error);
          this.toastrService.error('TÜRKAK servisine bağlanırken hata oluştu.');
          return;
        }
      } else {
        if (this.calibrationDevice.certificateCompanyTurkakId && this.selectedAcradtionOrganizationId == 1)
          this.toastrService.error("Bu firma türkaka kaydedilmemiştir", "Firma Türkak");
      }

      //this.turkakQrBase64 = await this.convertImageToBase64('/assets/logo/turkakqr2.png')
      console.log(turkakPayload);
      const createCalibration = new CreateCalibration();
      createCalibration.deliveryDeviceId = this.calibrationDevice.id;
      createCalibration.procedureId = this.selectProcedureId;
      createCalibration.personId = this.selectedPersonId;
      createCalibration.calibrationDate = new Date(calibrationDate);
      createCalibration.status = CalibrationStatus.Tamamlandı;
      createCalibration.environmentalConditionId = this.enviromentalContentId;
      createCalibration.accreditationOrganization = this.selectedAcradtionOrganizationId;
      createCalibration.isPlace = this.isPlace;
      createCalibration.acceptanceDate = this.date2[0] ?? this.date2;
      createCalibration.turkakCalibrationId = turkakCalibrationId;
      createCalibration.placeAddress = this.calibrationAddress;
      createCalibration.measurementFile = this.selectedFile;
      createCalibration.saveFilePath = this.saveFilePath;
      createCalibration.visualAndFunctional = this.certificateForm.value.visualAndFunctional;
      createCalibration.createCalibrationReferenceDevices = this.selectedDevices.map(p => ({
        deviceId: p.id,
        calibrationId: 0  // Backend'de güncellenecek
      }));
      console.log(createCalibration)
      const data = await this.calibrationService.createCalibration(createCalibration);
      console.log(data);
      if (data.status) {
        //this.closeModal();
        //this.router.navigate(['/admin/calibration']);
        await this.getByIdCalibration(data.data);
        await this.pdfDetail(true);
        //this.toastrService.success(data.message);
        //this.closeModal();
      } else {
        this.toastrService.error(data.message);
      }
    } else {
      await this.pdfDetail(false);
    }
  }

  pageCount: number = 2;
  calibration: any = {};
  async getByIdCalibration(id) {
    const data = await this.calibrationService.getByIdReadyCalibration(id);
    console.log(data);
    this.calibration = data;
    const missingFields = [];
    if (!this.calibration.deviceSeriNo) missingFields.push("Seri Numarası");
    if (!this.calibration.deviceBrand) missingFields.push("Marka");
    if (!this.calibration.deviceModel) missingFields.push("Model");
    if (!this.calibration.deviceResolution) missingFields.push("Çözünürlük");
    if (!this.calibration.devicePlace) missingFields.push("Yer");
    if (!this.calibration.deviceInventoryNumber) missingFields.push("Envanter No");
    if (!this.calibration.deviceReferenceMax && !this.calibration.deviceReferenceMin) missingFields.push("Cihaz Referans Aralığı");

    if (missingFields.length > 0) {
      const message = `Kalibrasyon yapılan cihazın şu bilgileri eksik: ${missingFields.join(", ")}`;
      this.toastrService.warning(message, "Eksik Bilgi Uyarısı", {
        progressBar: true,
        toastClass: 'toast ngx-toastr',
        closeButton: true,
        positionClass: 'toast-bottom-right',
      });
    }
    this.getAllCertificateReservations(data.deviceCompanyId);

    const fileName =
      `${this.calibrationDevice.seriNo ? this.calibrationDevice.seriNo + '-' : ''}` +
      `${this.calibrationDevice.code}-${this.calibrationDevice.deliveryCode}`;
    await this.getCalibrationMeasurementResultBase64(fileName);
  }

  qrCodeBase64: string;

  formatDateForFileName = (dateStr: string): string => {
    const date = new Date(dateStr);
    const yyyy = date.getFullYear();
    const MM = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const HH = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${yyyy}${MM}${dd}_${HH}${mm}${ss}`;
  };

  async generateQRCode(certificateNo: string): Promise<void> {
    // URL'yi oluşturuyoruz
    const url = `${this.backendUrl}api/Certificates/verify/${this.calibration.calibrationNo}-${certificateNo}.pdf`;

    try {
      const qrCanvas = document.createElement('canvas');
      await QRCode.toCanvas(qrCanvas, url, { width: 250 });

      // 2️⃣ Yeni bir canvas oluştur (QR + metin için)
      const finalCanvas = document.createElement('canvas');
      const ctx = finalCanvas.getContext('2d')!;
      const qrSize = qrCanvas.width;
      const textHeight = 40; // alt boşluk
      finalCanvas.width = qrSize;
      finalCanvas.height = qrSize + textHeight;

      // 3️⃣ QR kodu çiz
      ctx.drawImage(qrCanvas, 0, 0);

      // 4️⃣ Metni çiz
      ctx.font = 'bold 32px Arial';
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText(certificateNo, qrSize / 2, qrSize + 30);

      // 5️⃣ Base64 çıktısı al
      this.qrCodeBase64 = finalCanvas.toDataURL('image/png');
    } catch (err) {
      console.error('QR Kod oluşturulurken hata oluştu:', err);
    }
  }
  img: string[] = [];

  currentPage = 1;  // İlk sayfa
  totalPages = 0;
  pdfDoc: any = null; // PDF dosyasını tutacak
  isPdfDoc: boolean = false;

  clearFile(): void {
    this.pdfDoc = null; // Dosya adını null yaparak dosyayı "silmiş" oluyorum
    const input = document.getElementById('customFile') as HTMLInputElement;
    if (input) {
      input.value = ''; // Input değerini sıfırlıyoruz
    }
  }
  isPdfDocDetail() {
    this.isPdfDoc = !this.isPdfDoc;
  }

  selectedFile: File | null = null;
  saveFilePath: string | null = null;
  onFileSelected2(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    this.selectedFile = fileInput.files?.[0] ?? null;

    if (!this.selectedFile) return;

    this.selectedFileName = this.selectedFile.name; // seçilen dosya adı

    // uzantısız dosya adı
    const uploadedFileName =
      this.selectedFile.name.replace(/\.[^/.]+$/, '');

    const { seriNo, code, deliveryCode } = this.calibrationDevice;

    // kabul edilen dosya adları
    let validFileName: string = null;

    // seriNo varsa ikinci ihtimali ekle
    if (seriNo) {
      validFileName = (`${seriNo}-${code}-${deliveryCode}`);
    } else {
      validFileName = (`${code}-${deliveryCode}`);
    }

    this.saveFilePath = validFileName;

    // eşleşme kontrolü
    const isValid = uploadedFileName === validFileName;

    if (!isValid) {
      this.toastrService.error(
        `Dosya adı şu formatta olmalı:\n${validFileName}`,
        'Dosya Adı Hatalı',
        {
          timeOut: 10000,
          closeButton: true,
          progressBar: true,
          toastClass: 'toast ngx-toastr',
        }
      );

      // this.selectedFile = null;
      // this.selectedFileName = null;
      // fileInput.value = ''; // input'u temizle
    }
  }


  showEnviromenetConditionDialog() {
    const modal = this.modalService.open(CreateEnvironmentalConditionComponent, {
      size: 'lg',
      windowClass: 'modal modal-succes'
    });
    modal.result.then(async (res) => {
      if (res == true)
        await this.getAllEnvironmentalCondition(this.calibrationDevice.kindId);
    });

  }

  resetCertificateNumber() {
    this.certificateNumber = null;
  }
  /*  onFileSelected2(event: Event): void {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files ? fileInput.files[0] : null;
      this.img = [];
  
      const container = document.getElementById('pdf-container');
      if (container) {
        container.innerHTML = '';  // Eski görselleri temizle
      }
  
      const pdfBlob = new Blob([file], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
  
      const iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "800px";
      iframe.src = pdfUrl;
  
      // container içine ekle
      container?.appendChild(iframe);
  
      if (file) {
        const reader = new FileReader();
  
        // Dosya okuma işlemi tamamlandığında bu fonksiyon çalışacak
        reader.onload = (e: ProgressEvent<FileReader>) => {
          const typedArray = new Uint8Array(e.target?.result as ArrayBuffer);
  
          // PDF dosyasını pdf.js ile açıyoruz
          pdfjsLib.getDocument(typedArray).promise.then(pdf => {
            this.pdfDoc = pdf;  // PDF dokümanını tutuyoruz
            this.totalPages = pdf.numPages;  // Toplam sayfa sayısını alıyoruz
            const canvasArray: string[] = [];  // Her sayfa için Base64 görseli tutacak dizi
  
            // Sayfa render işlemi
            const renderPage = (pageNum: number) => {
              pdf.getPage(pageNum).then(page => {
                const scale = 4.0;
                const viewport = page.getViewport({ scale: scale });
  
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d')!;
  
                canvas.height = viewport.height;
                canvas.width = viewport.width;
  
                context.imageSmoothingEnabled = false;
  
                page.render({
                  canvasContext: context,
                  viewport: viewport
                }).promise.then(() => {
                  // Kırpma için yeni canvas oluştur
                  const cropCanvas = document.createElement('canvas');
                  const cropContext = cropCanvas.getContext('2d')!;
  
                  const cropTop = 340;    // üstten kırpılacak px
                  const cropBottom = 390; // alttan kırpılacak px
                  const cropLeft = 0;    // soldan kırpılacak px
                  const cropRight = 0;   // sağdan kırpılacak px
  
                  const cropHeight = canvas.height - cropTop - cropBottom;
                  const cropWidth = canvas.width - cropLeft - cropRight;
  
                  cropCanvas.width = cropWidth;   // genişlik aynı kalsın
                  cropCanvas.height = cropHeight;    // yükseklik kırpılmış olsun
  
                  cropContext.drawImage(
                    canvas,
                    cropLeft, cropTop,                 // kaynak başlangıç (x=0, y=cropTop)
                    cropWidth, cropHeight,      // kaynak boyut: kırpılmış genişlik & yükseklik
                    0, 0,                       // hedef başlangıç
                    cropWidth, cropHeight       // hedef boyut
                  );
  
                  const imgData = cropCanvas.toDataURL('image/png');
                  canvasArray[pageNum - 1] = imgData;
  
                  if (canvasArray.length === this.totalPages) {
                    this.img = canvasArray;
                    this.openAllPagesInNewTabs(canvasArray);
                  }
                });
  
              });
            };
  
            // Sayfaları sırayla işliyoruz
            for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
              renderPage(pageNum);
            }
          });
        };
  
        reader.readAsArrayBuffer(file);  // Dosyayı okuyoruz
      }
    }*/

  openAllPagesInNewTabs(imgDataArray: string[]) {
    const container = document.getElementById('pdf-container');  // Sayfada görselleri ekleyeceğimiz container

    imgDataArray.forEach(imgData => {
      const imgElement = document.createElement('img');
      imgElement.src = imgData;  // Base64 görseli img etiketi kaynağı olarak ayarlıyoruz
      imgElement.style.width = '100%';  // Görselin genişliğini sayfaya uyacak şekilde ayarlıyoruz
      imgElement.style.marginBottom = '20px';  // Sayfalar arasında boşluk bırakıyoruz
      container?.appendChild(imgElement);  // Görseli container'a ekliyoruz
    });
  }

  async convertImageToBase64(url: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // CORS hatalarını önlemek için
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(null);
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = (err) => {
        console.error("Resim yüklenemedi!", url, err);
        reject(null);
      };
    });
  }

  logo = null;
  getByIdLogo(number: number): string | null {
    const logos = Object.values(CalibrationlogoEnum);
    this.logo = logos[number - 1] || null;
    return this.logo;
  }
  customerSetting: GetCustomerSettingDetailDTO;
  async generatePDF(headerData: headerBilgileri, calibrationData: CalibrationData, calibrationPage2: CalibrationPage2, isSave: boolean = false) {
    // Convert image paths to Base64 asynchronously

    const data = await this.certificateService.createCertificate({
      //base64Data: base64Data,
      calibrationId: this.calibration.id,
      certificateNo: headerData.certificateNo.toString(),
      expiryDate: new Date(this.certificateForm.value.expiryDate[0]),
      issueDate: new Date(this.certificateForm.value.issueDate[0]),
      personId: this.certificateForm.value.personId
    });

    if (data.status) {
      this.closeModal();
      this.router.navigate(['/admin/delivery']);
      this.toastrService.success(data.message);
    } else {
      this.toastrService.error(data.message);
    }
    /*
    await this.pdfFontService.loadFonts();
    calibrationData.certificatePageNumber = this.pageCount + this.totalPages;
    // headerData.firmaLogo = await this.convertImageToBase64(headerData.firmaLogo) || '';
    let akraditasyonFirma = '';
    if (headerData.akraditationFirma === 1) {
      if (this.customerSetting.turkakLogo != null)
        akraditasyonFirma = this.customerSetting.turkakLogo;
    } else if (headerData.akraditationFirma === 2) {
      if (this.customerSetting.nacLogo != null)
        akraditasyonFirma = this.customerSetting.nacLogo;
    }
    else if (headerData.akraditationFirma === 3) {
      if (this.customerSetting.traceabilityLogoPath != null)
        akraditasyonFirma = this.customerSetting.traceabilityLogoPath
    } else if (headerData.akraditationFirma === 4) {
      if (this.customerSetting.iasLogo != null)
        akraditasyonFirma = this.customerSetting.iasLogo
    }
    if (this.selectProcedureId != null) {
      this.selectProcedure = this.kindProcedures?.find(p => p.id == this.selectProcedureId);
      console.log(this.selectProcedure);
    }
    // Document definition
    const documentDefinition = {
      pageSize: 'A4',
      pageMargins: [35, 215, 35, 90],
      background: (currentPage, pageSize) => {
        if (!this.company.companyFile64) return null;
        return {
          image: `${headerData.firmaLogo}`,
          width: 450,
          opacity: 0.1,
          absolutePosition: { x: 75, y: 300 }
        };
      },
      // Header for each page
      header: (currentPage, pageCount, pageSize) => {
        return this.getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData);
      },
      defaultStyle: {
        font: 'RobotoSerif', // Using the custom font
      },
      // Content of the document (multiple pages)
      content: [
        await this.createCalibrationPageContent(calibrationData, true),
        this.createCalibrationPage2(calibrationPage2),
        //this.createCalibrationOtherPage(this.img)
        ...this.measurementResultBase64
      ],
      // Footer for each page
      footer: (currentPage, pageCount) => this.getFooterContent(currentPage, pageCount, calibrationData.firtsPageFooterDescription)
    }
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition as unknown as TDocumentDefinitions);

    console.log(this.certificateForm.value);

    if (isSave) {
      this.isSaving = true; // işlem başladı
      try {
        pdfDocGenerator.getBase64(async (base64Data) => {
          try {

            // BURASIDA CERTİFİCATE SAVE DİALOĞUDA GÖZÜKECEK

            const data = await this.certificateService.createCertificate({
              //base64Data: base64Data,
              calibrationId: this.calibration.id,
              certificateNo: headerData.certificateNo.toString(),
              expiryDate: new Date(this.certificateForm.value.expiryDate[0]),
              issueDate: new Date(this.certificateForm.value.issueDate[0]),
              personId: this.certificateForm.value.personId
            });

            if (data.status) {
              this.closeModal();
              this.router.navigate(['/admin/calibration']);
              this.toastrService.success(data.message);
            } else {
              this.toastrService.error(data.message);
            }

          } catch (innerError) {
            console.error('Certificate creation error:', innerError);
            this.toastrService.error('Sertifika oluşturulurken bir hata oluştu.');
          } finally {
            this.isSaving = false; // işlem tamamlandı
          }
        });
      } catch (error) {
        console.error('PDF generation error:', error);
        this.toastrService.error('PDF oluşturulurken bir hata oluştu.');
        this.isSaving = false;
      }
    } else {

      pdfDocGenerator.open();
    }
    */
    // Generate and open the PDF
  }

  async createCalibrationPageContent(calibrationData: CalibrationData, pageBreak: boolean) {
    let firstPageDescriptionToHtml = htmlToPdfmake(calibrationData.firstPageDescription);
    firstPageDescriptionToHtml = this.applyDefaultFontSize(firstPageDescriptionToHtml, 8, 7);

    //const seal = await this.convertImageToBase64('/assets/logo/muhur.png').catch(err => console.log(err));
    //const imza1 = await this.convertImageToBase64('/assets/logo/e-imza.png').catch(err => console.log(err));
    let seal = this.customerSetting?.stampImage;
    await this.generateQRCode(calibrationData.certificateNo);
    return [
      {
        table: {
          widths: ['30%', '70%'], // İlk sütun başlık, ikinci sütun veri
          body: [
            [{ text: 'Cihaz Sahibi / Adresi', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceOwner}`, fontSize: 9 }],
            [{ text: 'Customer / Address', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, { text: `${calibrationData.address}`, fontSize: 7 }],

            [{ text: 'Sipariş Numarası', bold: true, fontSize: 9 }, { text: `${calibrationData.orderNumber ?? '-'}`, fontSize: 9 }],
            [{ text: 'Order No', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Cihaz', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceName}`, fontSize: 9 }],
            [{ text: 'Device', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'İmalatçı', bold: true, fontSize: 9 }, { text: `${calibrationData.manufacturer}`, fontSize: 9 }],
            [{ text: 'Brand', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Model / Tip', bold: true, fontSize: 9 }, { text: `${calibrationData.modelType}`, fontSize: 9 }],
            [{ text: 'Type', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: `Seri Numarası / Envanter No`, bold: true, fontSize: 9 }, { text: `${calibrationData.serialNumber}`, fontSize: 9 }],
            [{ text: 'Serial Number / Inventory Number', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Kalibrasyon Tarihi', bold: true, fontSize: 9 }, { text: `${calibrationData.calibrationDate}`, fontSize: 9 }],
            [{ text: 'Date of Calibration', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Sertifika Sayfa Sayısı', bold: true, fontSize: 9 }, { text: `${calibrationData.certificatePageNumber}`, fontSize: 9 }],
            [{ text: 'Number of Pages of The Certificate', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            // [{ text: 'Bulunduğu Yer', bold: true, fontSize: 9 }, { text: `${calibrationData.place}`, fontSize: 9 }],
            // [{ text: 'Location Of Equipment', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],
          ]
        },
        layout: 'noBorders', // Tablo çizgilerini kaldırdım
        margin: [0, -10, 0, 1],
      },
      {
        stack: [firstPageDescriptionToHtml],
        margin: [0, 5, 0, 10]
      },
      {
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [{ text: "Mühür", bold: true, fontSize: 8, alignment: 'center' }, { text: 'Yayımlanma Tarihi', bold: true, fontSize: 8, alignment: 'center' }, { text: "Kalibrasyon Yapan", bold: true, fontSize: 8, alignment: 'center' }, { text: "Onaylayan", bold: true, fontSize: 8, alignment: 'center' }],
            [{ text: "Seal", fontSize: 6, alignment: 'center', italics: true }, { text: 'Issue Date', fontSize: 8, alignment: 'center', italics: true }, { text: "Calibrated by", fontSize: 6, alignment: 'center', italics: true }, { text: "Approval", fontSize: 6, alignment: 'center', italics: true }],
            [
              { image: seal, fit: [85, 85], alignment: 'center' },
              { text: `${(this.certificateForm.value.issueDate[0]).toLocaleDateString('tr-TR')}`, fontSize: 10, alignment: 'center', marginTop: 15 },
              [
                { text: calibrationData.kalYapan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                {
                  text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000',
                }
              ],
              [
                { text: calibrationData.onaylayan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                {
                  text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000'
                },
                {
                  text: `${calibrationData.calibrationDate}`,
                  fontSize: 8,
                  alignment: 'center'
                }
              ],
            ]
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 0],
      },
      pageBreak ? { text: '', pageBreak: 'after' } : { text: '' },
    ];
  }

  applyDefaultFontSize(obj: any, normalFontSize: number = 7, smallFontSize: number = 5) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.applyDefaultFontSize(item, normalFontSize, smallFontSize));
    } else if (typeof obj === "object" && obj !== null) {
      // If the object contains text and doesn't have fontSize defined
      if (obj.text && !obj.fontSize) {
        // Apply the normal font size by default
        obj.fontSize = normalFontSize;
      }

      // Adjust the font size if 'ql-size-small' is present in style
      if (obj.text && obj.style?.includes("ql-size-small")) {
        obj.fontSize = smallFontSize; // Apply small font size
      }

      // If the object has margin, reduce it by 10%
      if (obj.margin) {
        obj.margin = obj.margin.map((m: number) => m * 0.1);
      }

      // Recursively apply the function to nested properties
      Object.keys(obj).forEach(key => {
        obj[key] = this.applyDefaultFontSize(obj[key], normalFontSize, smallFontSize);
      });
    }
    return obj;
  }

  createCalibrationPage2(calibrationPage2: CalibrationPage2) {
    let calibrationText = htmlToPdfmake(calibrationPage2.description);
    calibrationText = this.applyDefaultFontSize(calibrationText);

    let remaksToHtml = htmlToPdfmake(calibrationPage2.remarks);
    remaksToHtml = this.applyDefaultFontSize(remaksToHtml);

    let complianceToHtml = htmlToPdfmake(calibrationPage2.compliance);
    complianceToHtml = this.applyDefaultFontSize(complianceToHtml);

    let measurementToHtml = htmlToPdfmake(calibrationPage2.measurement);
    measurementToHtml = this.applyDefaultFontSize(measurementToHtml);
    return [
      {
        stack: [
          {
            text: [
              {
                text: "Kalibre Edilen Cihaz /", bold: true, fontSize: 10,
              },
              {
                text: "Device to be calibrate", fontSize: 8, italics: true
              },
            ],
            margin: [0, 0, 0, 0]
          },
          {
            columns: [
              {
                table: {
                  widths: ['50%', '50%'], // İki sütunlu tablo
                  body: [
                    // İlk tablo: Cihaz bilgileri
                    [{ text: 'Cihaz Adı / Device Name', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceName}`, fontSize: 8 }],
                    [{ text: 'Seri Numarası / Serial No', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.serialNo}`, fontSize: 8 }],
                    [{ text: 'Cihaz No / Device No', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceNumber}`, fontSize: 8 }],
                    [{ text: 'Bulunduğu Yer / Location', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.location}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              {
                table: {
                  widths: ['50%', '50%'], // İkinci tablo: Model ve ölçüm bilgileri
                  body: [
                    [{ text: 'Marka / Brand', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.brand}`, fontSize: 8 }],
                    [{ text: 'Model / Model', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.type}`, fontSize: 8 }],
                    [{ text: 'Çözünürlük / Resolution', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.resolution}`, fontSize: 8 }],
                    [{ text: 'Lab. Kabul Tarihi / Lab. Date', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.range}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              // Tabloların altındaki ek bilgiler
            ],
            margin: [0, 0, 0, 0],
          },
          {
            table: {
              widths: ['25%', '75%'],
              body: [
                [{ text: `Cihazın Kalibrasyon Yapıldığı Yer`, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.incomingDateOfDeviceLaboratory}`, fontSize: 8 }],
                [{ text: `Görsel ve Fonksiyonel Kontrol    `, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.visualFunctionInspectionDevice}`, fontSize: 8 }]
              ],
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyonda Kullanılan Cihazlar /", bold: true, fontSize: 10 },
                      { text: "References used in calibration", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ['27%', '13%', '13%', '14%', '10%', '10%', '13%'], // 7 sütun için genişlikleri belirledim
                  body: [
                    [{ text: 'Cihaz Adı', fontSize: 8, bold: true }, { text: 'Marka', fontSize: 8, bold: true }, { text: 'Model', fontSize: 8, bold: true }, { text: 'Seri No', fontSize: 8, bold: true }, { text: 'Sertifika No', fontSize: 8, bold: true }, { text: 'Kal. Tarihi', fontSize: 8, bold: true }, { text: 'İzlenebilirlik', fontSize: 8, bold: true }],
                    [{ text: 'Device Name', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Brand', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Model', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Serial No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Certificate No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Cal. Date', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Tracebility', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }],
                    ...calibrationPage2?.references?.map(ref => [
                      { text: ref.deviceName, fontSize: 8 },
                      { text: ref.brand, fontSize: 8 },
                      { text: ref.model, fontSize: 8 },
                      { text: ref.serialNumber, fontSize: 8 },
                      { text: ref.certificateNumber, fontSize: 8 },
                      { text: ref.calibrationDate, fontSize: 8 },
                      { text: ref.tracebility, fontSize: 8 } // İzlenebilirlik için örnek veri (isteğe bağlı)
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }

            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Çevre Şartları /", bold: true, fontSize: 10 },
                      { text: "Environment Conditions", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ["*", "*", "*"],
                  body: [
                    [{ text: "Tür / Kind", bold: true, fontSize: 8 }, { text: "Başlangıç / Start", bold: true, fontSize: 8 }, { text: "Bitiş / End", bold: true, fontSize: 8 }],
                    ...(calibrationPage2.evironmentalConditions || []).map(ref => [
                      { text: ref.name || "-", fontSize: 7 },
                      { text: ref.start || "-", fontSize: 7 },
                      { text: ref.end || "-", fontSize: 7 },
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyon Metodu /", bold: true, fontSize: 10 },
                      { text: "Calibration Method", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [calibrationText],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Açıklama /", bold: true, fontSize: 10 },
                      { text: "Remarks", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [remaksToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Uygunluk Beyanı /", bold: true, fontSize: 10 },
                      { text: "Statement Of Complance", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [complianceToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Ölçüm Belirsizliği /", bold: true, fontSize: 10 },
                      { text: "Measurement Uncertaintily", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [measurementToHtml]
              }
            ]
          },
        ],
        marginTop: -100
      },
      // Sayfa sonu eklemeleri (isteğe bağlı)
      { text: '', pageBreak: 'after' }, // Eğer sayfa sonu gerekiyorsa, sayfa kesme ekleyebilirsiniz
    ];
  }

  createCalibrationOtherPage(imgData: string[]) {
    const pageContent = [];
    // Sayfa başına bir görsel ekliyoruz ve her sayfada bir kırılma ekliyoruz.
    for (let i = 0; i < imgData.length; i++) {
      pageContent.push({
        image: imgData[i],
        alignment: 'center',
        fit: [580, 1400], // sayfaya sığacak şekilde
        //width:1200,
        //height:1440,
        margin: [0, 0, 0, 0], // Görsel ile header arasına boşluk bırakabiliriz
        absolutePosition: { x: 60, y: 100 }, // Y konumunu her sayfa için ayarlayabilirsiniz
        pageBreak: i < imgData.length - 1 ? 'after' : undefined // Son görselden sonra sayfa kırılması ekliyoruz
      });
    }
    return pageContent;
  }

  // Header content function
  getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData: headerBilgileri) {
    console.log("header akr fir : ", headerData.acradtionOrganizationId);
    return {
      stack: [
        {
          columns: [
            // Sol kolon
            { ...this.getLeftColumn(headerData, currentPage, pageCount), width: '25%' },

            // Orta kolon (esnek)
            {
              ...this.getCenterColumn(headerData, currentPage), width: '52%' // sağdaki tabloya 2 birim boşluk bırak
            },

            // Other logo (sağ logosu, tablo ile 2 birim boşluk bırak)
            headerData.acradtionOrganizationId != 3 ? {
              ...this.getOtherLogoColumn(headerData, currentPage),
              width: '*',
              margin: [0, 0, 2, 0], // sağdaki tabloya 2 birim boşluk bırak
            } :
              {
                text: '', width: '*',
                margin: [0, 0, 2, 0],
              },

            // Sağ kolon (tablo)
            {
              ...this.getRightColumn(
                akraditasyonFirma,
                headerData.akraditationNo,
                headerData.certificateNo,
                headerData.certificateTarih,
                currentPage,
                headerData.firmaAdi?.split(' ')[0],
                headerData.acradtionOrganizationId
              ),
              width: 'auto',
              // alignment: 'right'
            },
          ],
          margin: [35, 12, 35, 0],
        },
        {
          text: `Sayfa (Page): ${currentPage} / ${pageCount}`,
          fontSize: 8,
          alignment: 'left',
          margin: [35, 2, 0, 0]
        },
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
      ],
    };
  }

  getOtherLogoColumn(headerData, currentPage) {
    const otherLogoStack: any[] = [];
    if (this.customerSetting.otherLogo && currentPage === 1) {
      otherLogoStack.push({
        image: this.customerSetting.otherLogo,
        fit: [75, 90],
        alignment: 'rigth',
        margin: [0, 0, 0, 0]
      });
    } else {
      otherLogoStack.push({ text: '', width: 90, height: 90, opacity: 0 });
    }

    return {
      stack: otherLogoStack,
      alignment: 'rigth',
      minHeight: 100,
      // marginleft: -10
    };
  }

  // Left column content
  getLeftColumn(headerData, currentPage, totalPages) {
    const logoStack: any[] = [];

    if (headerData.firmaLogo && currentPage == 1) {
      logoStack.push({
        image: headerData.firmaLogo,
        fit: [150, 150],
        margin: [0, -20, 0, 0],
        alignment: 'left'
      });

      // 🔹 QR Code logonun hemen altına
      if (this.qrCodeBase64) {
        logoStack.push({
          image: this.qrCodeBase64,
          fit: [75, 75],
          margin: [20, 5, 0, 0],
          alignment: 'rigth'
        });
      }

    } /*else {
      logoStack.push(
        { text: "", fontSize: 10, italics: true },
        {
          text: `Sayfa (Page): ${currentPage} / ${totalPages}`,
          fontSize: 8,
          margin: [0, currentPage == 1 ? 10 : 10, 0, 0],
          alignment: 'left',
        }
      );
    }*/

    return {
      stack: logoStack,
      alignment: 'left',
      minHeight: 100,
      marginTop: 25
    };
  }

  // Center column content
  getCenterColumn(headerData, currentPage) {
    return {
      stack: [
        {
          noWrap: false,
          text: `${headerData.firmaAdi}`,
          italics: true,
          bold: true,
          fontSize: 12,
          lineHeight: 1.1,
          margin: [15, headerData.firmaAdi.length && currentPage != 1 > 30 ? 10 : 20, 2, currentPage != 1 ? 10 : 0]
        },
        currentPage == 1 ? { text: `${headerData.firmaAdresi}`, italics: true, fontSize: 10, marginTop: 10, marginLeft: 10 } : { text: '' },

        currentPage == 1 ? { text: "KALİBRASYON SERTİFİKASI", bold: true, fontSize: 12, margin: [0, 25, 0, 0] } : { text: '' },
        currentPage == 1 ? { text: "Calibration Certificate", italics: true, fontSize: 8 } : { text: '' },
      ],
      alignment: 'center',
      marginTop: 20,
      marginLeft: 10
    };
  }

  // Right column content
  getRightColumn(
    akraditasyonFirma,
    akraditationNo,
    certificateNo,
    certificateTarih,
    currentPage,
    companyName,
    akradetionNumber
  ) {
    akraditationNo = this.customerSetting.accreditationNo;
    this.certificateFirstNo = this.customerSetting.certificatePrefix;
    const rightStack: any[] = [];
    // Üst logo
    if (currentPage === 1 && akraditasyonFirma) {
      rightStack.push({
        image: akraditasyonFirma,
        witdh: 85,
        height: 85,
        fit: [75, 90],
        alignment: 'center', //center dı
        margin: [0, 5, 0, 0]
        // margin: (akradetionNumber == 2 || akradetionNumber == 3) ? [-10, 0, 0, 0] : [-10, 0, 0, 0]
      });
    } else {
      rightStack.push({ text: '', width: 100, height: 100, opacity: 0 });
    }

    // 🔹 Turkak QR sadece akradetionNumber 1 ise tabloyu komple kaldır ve QR koy
    if (this.coreConfig.isCalibratedTurkak === true && akradetionNumber == 1 && currentPage == 1) {
      rightStack.push({
        image: this.turkakQrBase64,
        fit: [65, 65],
        alignment: 'center',
        margin: [0, 5, 0, 0]
      });
      rightStack.push({
        //text: `${akraditationNo.slice(3).replace(/-/g, '') + '-' + certificateTarih + '-' + certificateNo}`,
        text: `${this.certificationBodyDocumentNumber}`,
        fontSize: 7,
        margin: [0, 0, 0, 0],
      });
    } else {
      // Diğer durumlarda tabloyu koru
      rightStack.push({
        table: {
          widths: [47],
          body: [
            ...(akradetionNumber != 3
              ? [[{ text: akraditationNo, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]
              : [[{ text: companyName?.toUpperCase(), alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]),
            [{ text: `${this.certificateFirstNo}${certificateNo}`, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }],
            [{ text: certificateTarih, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }],
          ],
        },
        marginLeft: 3,
        marginTop: 10
      });
    }

    return {
      stack: rightStack,
      alignment: 'center',
      minHeight: 100
    };
  }

  // Footer content function
  getFooterContent(currentPage, pageCount, firstPageFooterDescription) {

    if (currentPage > 2) {
      return {};
    }

    console.log(firstPageFooterDescription);
    let firstPageFooterDescriptionToHtml = htmlToPdfmake(firstPageFooterDescription);
    firstPageFooterDescriptionToHtml = this.applyDefaultFontSize(firstPageFooterDescriptionToHtml, 8, 8);

    // İlk sayfa için footer içeriğini ayarlarken margin ve padding ekliyoruz.
    return {
      stack: [
        // Footer'da bir çizgi ekliyoruz
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
        {
          stack: [
            firstPageFooterDescriptionToHtml,
            ...(this.selectProcedure ? [{ text: this.selectProcedure.formNo, fontSize: 8 }] : [])
          ],
          margin: [35, 10, 35, 20], // Alt margin'ini biraz daha azaltarak daha fazla alan bırakıyoruz
          fontSize: 8, // Font boyutunu küçültüyoruz
        },

      ],
      margin: [0, 0, 0, 0]
    };
  }

  async pdfDetail(isSave: boolean) {
    this._coreConfigService.setConfig({ emitEvent: true });
    this.getByIdLogo(this.calibration.accreditationOrganization)
    const logoKey = Object.keys(CalibrationlogoEnum);
    const key = logoKey[this.calibration.accreditationOrganization - 1];
    Object.keys(this.coreConfig.akraditasyonCompanies).find(k => k === key);
    const value = this.coreConfig.akraditasyonCompanies[key];
    console.log(value);
    if (this.calibration.akraditationCompanyFile) {
      if (!this.calibration.akraditationCompanyFile.startsWith('data:image/png;base64,')) {
        this.calibration.akraditationCompanyFile = 'data:image/png;base64,' + this.calibration.akraditationCompanyFile;
      }
    }

    const issueDate: Date = new Date(this.calibration.calibrationDate);
    const year = issueDate.getFullYear().toString().slice(-2); // Yılın son iki basamağını al
    const month = (issueDate.getMonth() + 1).toString().padStart(2, '0'); // Ayı iki basamağa tamamla
    const formattedDate = month + '.' + year;

    const headerBilgi: headerBilgileri = {
      akraditationNo: value ?? '',
      akraditationFirma: this.calibration.accreditationOrganization ?? '',
      certificateNo: this.certificateNumber,
      certificateTarih: formattedDate,
      firmaAdi: this.calibration.akraditationCompany,
      firmaAdresi: this.calibration.akraditationCompanyAddres ?? '',
      firmaLogo: this.calibration.akraditationCompanyFile ?? '',
      acradtionOrganizationId: this.selectedAcradtionOrganizationId
    }

    const calibrationDate = new Date(this.calibration.calibrationDate);
    const formattedCalibrationDate = `${calibrationDate.getDate().toString().padStart(2, '0')}.${(calibrationDate.getMonth() + 1).toString().padStart(2, '0')}.${calibrationDate.getFullYear()}`;

    const confirmedPerson = this.calCompanyPerson?.find(p => p.id == this.certificateForm.value.personId);
    console.log(confirmedPerson)

    const calibrationData: CalibrationData = {
      deviceOwner: this.calibrationDevice.certficateCompany,
      address: this.calibrationDevice.certificateCompanyAddress ?? '',
      orderNumber: this.calibration.transactionManagementNo,
      deviceName: this.calibration.deviceName,
      manufacturer: this.calibration.deviceBrand,
      modelType: this.calibration.deviceModel,
      serialNumber: this.calibration.deviceSeriNo + '\t' + (this.calibration.deviceInventoryNumber != null ? '/' : '') + '\t' + (this.calibration.deviceInventoryNumber ?? ''),
      calibrationDate: formattedCalibrationDate,
      certificateNo: this.certificateNumber,
      firstPageDescription: (this.calibration.firstPageDescriptions && this.calibration.firstPageDescriptions.length > 0)
        ? (this.selectedAcradtionOrganizationId == 3 ? this.calibration.firstPageDescriptions[2].description :
          this.calibration.firstPageDescriptions[0].description)
        : '',
      kalYapan: this.calibration.person,
      onaylayan: confirmedPerson?.fullName ?? '',
      certificatePageNumber: this.pageCount + this.totalPages,
      firtsPageFooterDescription: (this.calibration.firstPageDescriptions && this.calibration.firstPageDescriptions.length > 1)
        ? this.calibration.firstPageDescriptions[1].description
        : '',
      place: this.calibration.devicePlace ?? ''
    };

    const referenceString = (this.calibration.deviceReferenceMin && this.calibration.deviceReferenceMax && this.calibration.deviceReferenceUnitType)
      ? `${this.calibration.deviceReferenceMin}-${this.calibration.deviceReferenceMax} ${this.calibration.deviceReferenceUnitType}`
      : '-';
    const deliveryDate = new Date(this.calibration.deliveryDate);

    const formattedDeliveryDate = `${deliveryDate.getDate().toString().padStart(2, '0')}.${(deliveryDate.getMonth() + 1).toString().padStart(2, '0')}.${deliveryDate.getFullYear()}`;

    const references: Reference[] = this.calibration.calibrationReferencesDevices?.map(device => ({
      deviceName: device.deviceName,
      brand: device.brandName,  // 'brandName' -> 'brand'
      model: device.modelName,  // 'modelName' -> 'model'
      serialNumber: device.seriNo,  // 'seriNo' -> 'serialNumber'
      certificateNumber: device.referenceDeviceMovement.calibrationNo,  // 'calibrationNo' -> 'certificateNumber'
      calibrationDate: this.formatDate(device.referenceDeviceMovement.calibrationDate),  // Format edilmiş tarih
      tracebility: device.referenceDeviceMovement.traceability  // 'traceability' -> 'tracebility'
    }));

    const calibrationDataPage2: CalibrationPage2 = {
      device: {
        deviceName: this.calibration.deviceName,
        serialNo: this.calibration.deviceSeriNo,
        deviceNumber: this.calibrationDevice.inventoryNumber ?? '-',
        location: this.calibration.devicePlace ?? '-',
        brand: this.calibration.deviceBrand,
        type: this.calibration.deviceModel,
        range: this.calibration.isPlace ? 'Yerinde' : formattedDeliveryDate, //referenceString, referans aralığıydı artık onun yerine tarih geldi buraya
        resolution: this.calibration.deviceResolution ?? '-',
        incomingDateOfDeviceLaboratory: this.calibrationAddress, //this.calibration.isPlace ? 'Yerinde' : formattedDeliveryDate,
        visualFunctionInspectionDevice: this.certificateForm.value.visualAndFunctional ? 'Uygun' : 'Uygun Değil'
      },
      references: references ?? [],
      evironmentalConditions: this.calibration.enviromentalContents,
      calibrationMethod: this.calibration.calibrationMethodDescription,
      remarks: this.calibration.procedureDescription,
      compliance: this.calibration.conformityDeclartion,
      measurement: this.calibration.measurementUncertaintyDescription,
      measurementUncertainty: this.calibration.measurementUncertaintyDescription,
      description: this.calibration.calibrationMethodDescription
    };

    await this.generatePDF(headerBilgi, calibrationData, calibrationDataPage2, isSave);
  }

  formatDate(date: string): string {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Aylar 0'dan başladığı için +1 yapıyoruz
    const year = newDate.getFullYear();
    return `${day}.${month}.${year}`;  // Gün.Ay.Yıl formatı
  }
}
